import React from 'react';
import { Section } from './ui/Section';
export function ComparisonTable() {
  const rows = [{
    without: 'Improvisas cada clase',
    with: 'Clase lista en 10 min'
  }, {
    without: 'Siempre las mismas figuras',
    with: '+40 figuras clasificadas'
  }, {
    without: 'Alumnos que se van sin avisar',
    with: 'Sistema de retención de 90 días'
  }, {
    without: 'No sabes cómo enseñar sensual',
    with: 'Protocolo claro y sin incomodidad'
  }, {
    without: 'Buen bailarín, mal instructor',
    with: 'Instructor de referencia en tu ciudad'
  }];
  return <Section data-id="element-75">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-76">
        ❌ vs ✅
      </h2>

      <div className="overflow-x-auto" data-id="element-77">
        <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-78">
          ← Scroll to see full table →
        </div>
        <table className="w-full min-w-[600px] border-collapse bg-gradient-card rounded-2xl overflow-hidden shadow-card border border-brand-border" data-id="element-79">
          <thead data-id="element-80">
            <tr className="bg-brand-card/50 border-b border-brand-borderGlow/20" data-id="element-81">
              <th className="text-left p-4 text-brand-textMuted font-heading font-semibold w-1/2 tracking-wide uppercase text-sm" data-id="element-82">
                ❌ Sin el Manual
              </th>
              <th className="text-left p-4 text-brand-title font-heading font-bold w-1/2 tracking-wide uppercase text-sm" data-id="element-83">
                ✅ Con el Manual
              </th>
            </tr>
          </thead>
          <tbody data-id="element-84">
            {rows.map((row, i) => <tr key={i} className="hover:bg-brand-card/30 transition-colors border-b border-brand-border/30 last:border-0" data-id="element-85">
                <td className="p-4 text-brand-text font-body" data-id="element-86">{row.without}</td>
                <td className="p-4 text-brand-subtitle font-body font-semibold" data-id="element-87">
                  {row.with}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Section>;
}